import { render, staticRenderFns } from "./SingleVehicleMsg.vue?vue&type=template&id=00b27964&scoped=true"
import script from "./SingleVehicleMsg.vue?vue&type=script&lang=js"
export * from "./SingleVehicleMsg.vue?vue&type=script&lang=js"
import style0 from "./SingleVehicleMsg.vue?vue&type=style&index=0&id=00b27964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b27964",
  null
  
)

export default component.exports